import { View } from 'react-native'
import { translate } from '../../../i18n'
import { styles } from './LeaderboardInformationStyle'
import { InfoItem } from './partial/InfoItem/InfoItem'
import React from 'react'

interface LeaderboardInformationProps {
  myRank: number
  numEntries: number
  runTime: string
  prizePool: number
}

export const LeaderboardInformation: React.FC<LeaderboardInformationProps> = ({ myRank, numEntries, runTime, prizePool }) => {
  return (
    <View style={styles.informationGame}>
      <InfoItem text={translate('leaderboard.myRank')} value={myRank.toString()} highlight={myRank >= 1} />
      <InfoItem text={translate('leaderboard.entries')} value={numEntries.toString()} />
      <InfoItem text={translate('leaderboard.runtime')} value={runTime} />
      <InfoItem text={translate('leaderboard.prizePool')} value={prizePool.toString()} />
    </View>
  )
}
